module.exports = __webpack_public_path__ + "6c7f8c134d8c1615272030a30a28ea95.pdf";